import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useSearchParams } from "@/hooks/useSearchParams";
import { useCallback, useEffect, useMemo } from "react";
import { ISelectPaymentParams } from "@/types/base";
import { CountryCodeEnum } from "@/components/SelectUserCountry/types";
import { countryNameByCountryCode } from "@/components/SelectUserCountry/constants";

const UserCountryLabel = "User Residence";

export const SelectUserCountry = () => {
  const countries = useMemo(() => Object.values(CountryCodeEnum), []);

  const { parsedSearchParams, mergeSearchParams } =
    useSearchParams<ISelectPaymentParams>();
  const { country } = parsedSearchParams || "";

  useEffect(() => {
    if (countries?.length && country === undefined) {
      mergeSearchParams({
        country: countries[0],
      });
    }
  }, [mergeSearchParams, countries, country]);

  const handleUserCountryChange = useCallback(
    (event: SelectChangeEvent) => {
      mergeSearchParams({
        country: event?.target.value,
      });
    },
    [mergeSearchParams],
  );

  return (
    <FormControl>
      <InputLabel>{UserCountryLabel}</InputLabel>
      <Select
        label={UserCountryLabel}
        value={country || ""}
        onChange={handleUserCountryChange}
      >
        {countries?.map((option) => (
          <MenuItem key={option} value={option}>
            {countryNameByCountryCode[option]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
